module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/axios/index.js
// module id = 10
// module chunks = 0